package tools

import kotlinx.browser.window

fun localUrl(pathAndQuery: String): String =
        "${window.location.origin}/$pathAndQuery"
